import {createSelector} from 'reselect';
import GlobalState from '../../../root-state';

const selectWinloses = (state : GlobalState) => state.food.winloses;

export const foodWinlosesSelector = createSelector(
    [selectWinloses],
    data => data
)
